export default __webpack_public_path__ + "static/media/background.e4c5fb40.jpg";